export enum Classes {
    thumbContainer = 'thumbContainer',
    thumbIconContainer = 'thumbIconContainer',
}

export enum FormConst {
    FallbackProfileProps = '_fallback_profile',
}
